var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 19",
    style: {
      enableBackground: "new 0 0 19 19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.2,12.5c0.7,0,1.3,0.3,1.8,0.7c0.5,0.5,0.7,1.1,0.7,1.8c0,0.7-0.3,1.3-0.7,1.8c-0.5,0.5-1.1,0.7-1.8,0.7 c-0.5,0-1-0.2-1.5-0.5c-0.4-0.3-0.8-0.7-0.9-1.2h-1v-1.7h1C12.1,13.2,13.1,12.5,14.2,12.5z M14.2,14.2c-0.2,0-0.4,0.1-0.6,0.2 c-0.2,0.2-0.2,0.4-0.2,0.6c0,0.2,0.1,0.4,0.2,0.6c0.2,0.2,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2c0.2-0.2,0.2-0.4,0.2-0.6 c0-0.2-0.1-0.4-0.2-0.6C14.6,14.3,14.4,14.2,14.2,14.2z M14.2,6.6c0.3,0,0.6-0.1,0.9-0.4c0.2-0.2,0.4-0.5,0.4-0.9 c0-0.3-0.1-0.6-0.4-0.9c-0.2-0.2-0.5-0.4-0.9-0.4c-0.3,0-0.6,0.1-0.9,0.4C13.1,4.7,13,5,13,5.4c0,0.3,0.1,0.6,0.4,0.9 C13.5,6.4,13.9,6.6,14.2,6.6z M14.2,2c0.9,0,1.8,0.4,2.4,1c0.6,0.6,1,1.5,1,2.4c0,2.5-3.4,6.3-3.4,6.3s-3.4-3.8-3.4-6.3 c0-0.9,0.4-1.8,1-2.4C12.4,2.3,13.3,2,14.2,2z M6.4,14.2h1v1.7h-1c-0.2,0.5-0.5,0.9-0.9,1.2S4.5,17.6,4,17.6c-0.7,0-1.3-0.3-1.8-0.7 c-0.5-0.5-0.7-1.1-0.7-1.8c0-1.1,0.7-2.1,1.7-2.4v-1h1.7v1C5.5,12.9,6.1,13.5,6.4,14.2z M4,14.2c-0.2,0-0.4,0.1-0.6,0.2 c-0.2,0.2-0.2,0.4-0.2,0.6c0,0.2,0.1,0.4,0.2,0.6c0.2,0.2,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2c0.2-0.2,0.2-0.4,0.2-0.6 c0-0.2-0.1-0.4-0.2-0.6C4.4,14.3,4.2,14.2,4,14.2z M4,2.3c0.7,0,1.3,0.3,1.8,0.7c0.5,0.5,0.7,1.1,0.7,1.8c0,1.1-0.7,2.1-1.7,2.4v1 H3.1v-1C2.6,7.1,2.2,6.8,1.9,6.3S1.4,5.4,1.4,4.9c0-0.7,0.3-1.3,0.7-1.8C2.7,2.6,3.3,2.3,4,2.3z M4,4C3.8,4,3.5,4.1,3.4,4.3 C3.2,4.4,3.1,4.6,3.1,4.9c0,0.2,0.1,0.4,0.2,0.6C3.5,5.6,3.8,5.7,4,5.7c0.2,0,0.4-0.1,0.6-0.2c0.2-0.2,0.2-0.4,0.2-0.6 c0-0.2-0.1-0.4-0.2-0.6S4.2,4,4,4z M8.2,15.9v-1.7h1.7v1.7H8.2z M4.8,10.8H3.1V9.1h1.7V10.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.db738cb3f6cb95ea18c4e47a0c5713ed.svg";
export { ForwardRef as ReactComponent };